import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import find from 'lodash.find';
import { InitiativeActionCreators, AppActionCreators } from '../../../actions';
import { AttachmentType, InitiativeMode, InitiativeType } from '../../../utils/enums';
import { ContactListItemInitiative } from './ContactListItemInitiative';
import { RouteUrls } from '../../../configs/routeUrls';

class ContactListItem extends Component {
	render() {
		const {
			isAuth,
			officeId,
			attachmentConfiguration,
			reCaptchaConfig,
			mapConfiguration,
			initiativeMode,
			isInitiativeCreating,
			createConsultationInitiative,
			title,
			thematicAreaId,
			districtId,
			projectId,
			onCancel,
			agreementAccepted,
			agreementHistory,
			agreementAcceptedRequired,
			scrollToAgreement,
			disabled = false
		} = this.props;

		return (
			<ContactListItemInitiative
				disabled={disabled}
				isAuth={isAuth}
				attachmentConfiguration={attachmentConfiguration}
				reCaptchaConfig={reCaptchaConfig}
				mapConfiguration={mapConfiguration}
				mode={initiativeMode}
				isInitiativeCreating={isInitiativeCreating}
				onSubmit={createConsultationInitiative}
				type={InitiativeType.ConsultationProposal}
				title={title}
				officeId={officeId}
				thematicAreaId={thematicAreaId}
				districtId={districtId}
				projectId={projectId}
				onCancel={onCancel}
				agreementAccepted={agreementAccepted}
				agreementHistory={agreementHistory}
				agreementAcceptedRequired={agreementAcceptedRequired}
				scrollToAgreement={scrollToAgreement}
			/>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		isAuth: state.app.isAuth,
		attachmentConfiguration: find(state.app.attachmentConfiguration, { placeOfUse: AttachmentType.Initiative }) || {
			maxAttachmentQuantity: 3,
			maxAttachmentSize: 5,
			maxAllAttachmentsSize: 15
		},
		reCaptchaConfig: state.app.reCaptchaConfiguration || {
			reCaptchaKey: 'http://192.168.43.83:6000/api/recaptcha'
		},
		mapConfiguration: state.app.mapConfiguration,
		initiativeMode: state.app.initiativeConfiguration.mode || InitiativeMode.Hidden,
		isInitiativeCreating: state.initiative.isInitiativeCreating
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		...bindActionCreators({ ...InitiativeActionCreators, ...AppActionCreators }, dispatch),
		goTo: (url) => dispatch(push(url))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactListItem);
